// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/common/element-variables.scss'
import storage from '@/storage'
import store from '@/store'
import api from '@/api'
import utils from '@/utils'
import pubFunction from '@/common/function'
import './common/index.css' // 公共css

import Vue2OrgTree from '@/components/org-tree/org-tree' // 引入树形结构图
import '@/components/org-tree/index.js' // 树形结构图处理name
import '@/components/org-tree/org-tree.less' // 树形结构图的样式

import echarts from '@/common/echarts.js'
import JsonViewer from 'vue-json-viewer'
import VueClipboard from 'vue-clipboard2'
import i18n from '@/lang'

Vue.use(JsonViewer)
Vue.use(VueClipboard)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Vue2OrgTree)

// 定义全局api变量
Vue.prototype.$FUN = pubFunction
Vue.prototype.$api = api
Vue.prototype.$storage = storage
Vue.prototype.$echarts = echarts
Vue.prototype.$u = utils

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js